import { ReactNode } from 'react';

import NotFound from '@/pages/NotFound';
import { useSession } from '@/providers/SessionProvider/SessionProvider';

interface IWithDevelopersAccess {
  children?: ReactNode;
}
const WithDevelopersAccess = ({ children }: IWithDevelopersAccess) => {
  const { currentUser } = useSession();
  if (currentUser?.isDeveloper) {
    return children;
  } else {
    return <NotFound />;
  }
};
export default WithDevelopersAccess;
